import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown, IconButton } from '@dixa/lib-shared-habla';
import { useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { analytics } from 'app/utils/segment';
import { getChannelName } from 'utils/channels';
import { mediaAttributes } from 'utils/channels/media';
import { listToAPStyleComma } from 'utils/formatting/string';
import { requestMicrophoneAccess, } from 'utils/telephony/microphone';
import { getSimulaneousRingHelpText, getSimulaneousRingHelpTitle, } from '../utils/simultaneousRingHelpText';
import { PresenceDropdownItem, PresenceDropdownSeparator, PresenceToggle, } from './PresenceDropdownItem';
import styles from './presenceDropdown.module.scss';
const channelLabelMap = {
    voicemail: 'Voicemail',
    email: 'Email',
    contactform: 'Contact form',
    callback: 'Callback',
    pstnphone: 'Phone',
    interactivechat: 'Chat',
    speak: 'Voice',
    messaging: 'Messaging',
};
export const PresenceDropdown = ({ statusText, metaWorkingMedia, errorMicrophoneErrorShowModal, presence, hasPhoneChannel, oppositePresenceStatus, telephony, presenceSetMedia, presenceSetMediaChannel, personalToggleRememberMicrophoneAccess, validPhoneNumber, isInTrial, profile, toggleSimultaneousRing, changeYourStatus, showLogoutModal, }) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    useClickAway(dropdownRef, () => {
        setShowDropdown(false);
    });
    const handleMediaClick = (metaMedia) => {
        if (metaMedia.name === 'speak' && telephony.isMicrophoneBlocked) {
            requestMicrophoneAccess()
                .then(errorMicrophoneErrorShowModal)
                .catch(errorMicrophoneErrorShowModal)
                .finally(() => {
                // Remove the remember my microphone access.
                personalToggleRememberMicrophoneAccess({
                    value: false,
                });
            });
        }
        else {
            const working = !metaMedia.working;
            presenceSetMedia({ media: metaMedia.name, working }).then(() => {
                analytics.presenceMediaUpdated({
                    media: metaMedia.name,
                    enabled: working,
                    location: 'topbarDropdown',
                });
            });
        }
    };
    const handleChannelClick = (conversation_channel) => {
        const workingMedia = presence.working_channels.find(({ conversation_channel: workingChannel }) => workingChannel === conversation_channel);
        if (conversation_channel === 'pstnphone' ||
            conversation_channel === 'callback') {
            if (telephony.isMicrophoneBlocked === true) {
                requestMicrophoneAccess()
                    .then(() => {
                    errorMicrophoneErrorShowModal();
                })
                    .catch((microphoneResponse) => {
                    errorMicrophoneErrorShowModal(microphoneResponse);
                });
            }
            else {
                presenceSetMediaChannel({
                    working: !workingMedia.working,
                    channel: conversation_channel,
                });
            }
        }
        else {
            presenceSetMediaChannel({
                working: !workingMedia.working,
                channel: conversation_channel,
            });
        }
    };
    return (_jsxs("div", Object.assign({ ref: dropdownRef, style: { position: 'relative' } }, { children: [_jsx(IconButton, { className: styles.dropdownButton, icon: "angle-down", variant: "secondary", onClick: () => {
                    setShowDropdown(!showDropdown);
                }, "data-testid": "presence-dropdown-button" }), _jsx(Dropdown, Object.assign({ isOpen: showDropdown, "data-testid": "presence-dropdown-menu" }, { children: _jsxs("ul", Object.assign({ className: styles.dropdown }, { children: [_jsx(PresenceDropdownItem, Object.assign({ icon: "working", text: statusText, tooltipText: `Set ${oppositePresenceStatus}`, descriptionTestId: "presence-dropdown-status" }, { children: _jsx(PresenceToggle, { id: "working-status", active: presence.status === 'working', onToggle: () => changeYourStatus('topbarDropdown') }) })), _jsx(PresenceDropdownSeparator, {}), metaWorkingMedia.map((metaMedia) => {
                            var _a;
                            const tooltip = listToAPStyleComma(metaMedia.channels.map(getChannelName));
                            const mediaName = mediaAttributes[metaMedia.name].name;
                            const tooltipButton = `Turn ${mediaName} ${metaMedia.working ? 'off' : 'on'}`;
                            return (_jsx(PresenceDropdownItem, Object.assign({ icon: mediaAttributes[metaMedia.name].icon, text: channelLabelMap[metaMedia.name], tooltipText: tooltip, subitems: metaMedia.name === 'speak'
                                    ? [
                                        _jsx(PresenceDropdownItem, Object.assign({ icon: "voicemail", text: "Voicemail", isSubitem: true }, { children: _jsx(PresenceToggle, { id: "voicemail", active: (_a = presence.working_channels.find(({ conversation_channel }) => conversation_channel === 'voicemail')) === null || _a === void 0 ? void 0 : _a.working, isAway: presence.status !== 'working', onToggle: () => {
                                                    handleChannelClick('voicemail');
                                                } }) }), 'speak'),
                                    ]
                                    : undefined }, { children: _jsx(PresenceToggle, { id: metaMedia.name, active: metaMedia.working, isAway: presence.status !== 'working', onToggle: () => {
                                        handleMediaClick(metaMedia);
                                    }, tooltipText: tooltipButton }) }), metaMedia.name));
                        }), _jsx(PresenceDropdownSeparator, {}), hasPhoneChannel && (_jsxs(_Fragment, { children: [_jsx(PresenceDropdownItem, Object.assign({ icon: "simultaneous", text: "Simultaneous Ring", helpText: getSimulaneousRingHelpText(validPhoneNumber, isInTrial, profile.phone_number), helpTitle: getSimulaneousRingHelpTitle(validPhoneNumber, isInTrial) }, { children: _jsx(PresenceToggle, { id: "simultaneous-ring", active: presence.presence_status.simultaneous_ringing === true, onToggle: () => toggleSimultaneousRing('topbarDropdown'), isAway: presence.status !== 'working' }) })), _jsx(PresenceDropdownSeparator, {})] })), _jsx(PresenceDropdownItem, { icon: "sign-out", text: "Sign out", onClick: showLogoutModal })] })) }))] })));
};
